<template>
  <div
    ref="chatSidebar"
    class="chat-sidebar"
  >
    <chat-sidebar-header-loading />
    <chat-sidebar-loading />
  </div>

  <div class="chat-content">
    <chat-content-header-empty-or-loading class="chat-content-header" />
    <chat-background
      class="d-flex column flex-grow-1"
      :theme-color="chatSettings?.themeColor"
      :show-theme-pattern="chatSettings?.showThemePattern"
    >
      <div class="flex-grow-1 align-content-center">
        <chat-content-not-selected disabled />
      </div>
      <chat-message-editor-loading />
    </chat-background>
  </div>
</template>

<script setup lang="ts">
import ChatSidebarHeaderLoading from '@/components/domain/chats/sidebar/header/ChatSidebarHeaderLoading.vue'
import ChatSidebarLoading from '@/components/domain/chats/sidebar/ChatSidebarLoading.vue'
import ChatMessageEditorLoading from '@/components/domain/chats/content/ChatMessageEditorLoading.vue'
import ChatContentNotSelected from '@/components/domain/chats/content/contentEmpty/ChatContentNotSelected.vue'
import ChatContentHeaderEmptyOrLoading from '@/components/domain/chats/content/header/ChatContentHeaderEmptyOrLoading.vue'
import ChatBackground from '@/components/domain/chats/content/ChatBackground.vue'
import { ref, watch } from '@/composition/vue/compositionApi'
import { useLocalStorageValue } from '@/composition/localStorageValue'
import { CHAT_LEFT_SIDEBAR_WIDTH } from '@/components/domain/chats/types'
import { useChatWidth } from '@/composition/domain/chats/chatWidth'
import type ChatSettings from '@/data/models/domain/chats/ChatSettings'

defineOptions({
  inheritAttrs: false,
})

defineProps<{
  chatSettings: ChatSettings | null
}>()

const chatSidebar = ref<HTMLDivElement | null>(null)

watch(chatSidebar, (newValue) => {
  if (newValue) {
    const storage = useLocalStorageValue<number>(CHAT_LEFT_SIDEBAR_WIDTH)
    const width = storage.get()
    if (width) {
      newValue.style.setProperty('max-width', `${width}px`)
      newValue.style.setProperty('min-width', `${width}px`)
    } else {
      const { sidebarWidth } = useChatWidth()
      newValue.style.setProperty('max-width', `${sidebarWidth.value}px`)
      newValue.style.setProperty('min-width', `${sidebarWidth.value}px`)
    }
  }
})
</script>
